import React from "react";
import { FrameIcon, IconFillStyles, LockIcon, PencilIcon } from "../components/Iconset";

export enum ProjectStates {
	InProgress = "WORK_IN_PROGRESS",
	InReview = "UNDER_REVIEW",
	ChangesRequested = "CHANGE_REQUESTED_DUMMY",
	MajorChangesRequested = "CHANGE_REQUESTED",
	MinorChangesRequested = "MINOR_CHANGE_REQUESTED",
	Approved = "APPROVED",
	Archived = "ARCHIVED",
}

export interface IProjectStateRenderData {
	label: string;
	color: string;
	backgroundColor: string;
	icon?: JSX.Element;
	iconFill?: IconFillStyles;
	children?: Map<ProjectStates, IProjectStateRenderData>;
	hiddenInDropdown?: boolean;
	hiddenInHistory?: boolean;
	selectable?: boolean;
}

export const projectStatesRenderData = new Map<ProjectStates, IProjectStateRenderData>([
	[ProjectStates.InProgress, { 
		label: "In Progress", 
		color: "#FFFFFF", 
		backgroundColor: 'rgba(255, 255, 255, 0.1)',
		iconFill: IconFillStyles.white,
		icon: <PencilIcon />
	}],
	[ProjectStates.InReview, { 
		label: "In Review", 
		color: "#CF53EE", 
		backgroundColor: 'rgba(207, 83, 238, 0.1)',
		iconFill: IconFillStyles.magenta,
		icon: <LockIcon />
	}],
	[ProjectStates.ChangesRequested, { 
		label: "Changes Requested", 
		color: "#FFFFFF", 
		backgroundColor: 'rgba(255, 255, 255, 0.1)', 
		iconFill: IconFillStyles.white,
		icon: <PencilIcon />,
		hiddenInHistory: true,
		selectable: false,
		children: new Map([
			[ProjectStates.MajorChangesRequested, {
				label: "Major Changes Requested",
				color: "#FFFFFF",
				backgroundColor: 'rgba(255, 255, 255, 0.1)',
			}], 
			[ProjectStates.MinorChangesRequested, {
				label: "Minor Changes Requested",
				color: "#FFFFFF",
				backgroundColor: 'rgba(255, 255, 255, 0.1)',
			}]
		])
	}],
	[ProjectStates.Approved, { 
		label: "Approved", 
		color: "#26BB66", 
		backgroundColor: 'rgba(38, 187, 102, 0.1)', 
		iconFill: IconFillStyles.green,
		icon: <LockIcon />
	}],
	[ProjectStates.Archived, { 
		label: "Archive", 
		color: "#EB5757 ", 
		backgroundColor: 'rgba(235, 87, 87, 0.1)', 
		iconFill: IconFillStyles.red,
		icon: <FrameIcon />
	}],
	[ProjectStates.MajorChangesRequested, {
		label: "Major Changes Requested",
		color: "#FFFFFF",
		backgroundColor: 'rgba(255, 255, 255, 0.1)',
		iconFill: IconFillStyles.white,
		icon: <PencilIcon />,
		hiddenInDropdown: true
	}],
	[ProjectStates.MinorChangesRequested, {
		label: "Minor Changes Requested",
		color: "#FFFFFF",
		backgroundColor: 'rgba(255, 255, 255, 0.1)',
		iconFill: IconFillStyles.white,
		icon: <PencilIcon />,
		hiddenInDropdown: true
	}]
]);